export default __webpack_public_path__ + "img/627e2341433ede14a03888a60c567eb0.png";